import { removeLocalStorageKey } from './local-storage';

let reloading = false;

export function handleSessionExpired() {
    if (reloading) return;
    reloading = true;
    alert('Session Expired. Click OK to sign in again');
    removeLocalStorageKey('session');
    window.location.reload();
}
